import { Action, createReducer, on } from '@ngrx/store';
import { INSAutoCompleteGroup, INSAutoCompleteOption } from '@norfolk-southern/accessns-components';

import * as RateFormActions from '@ruby/modules/rate-inquiry/store/actions/rate-form.actions';
import { IStationDetail } from '@ruby/shared/models/commons/station.interface';
import { ICarType } from '@ruby/shared/models/rate-inquiry/cartype.interface';
import { IError } from '@ruby/shared/models/request/error.interface';

export const featureKey = 'form';

export interface State {
  states: Array<INSAutoCompleteGroup>;
  stcc: Array<INSAutoCompleteOption>;
  originStations: Array<IStationDetail>;
  destinationStations: Array<IStationDetail>;
  carOwners: Array<INSAutoCompleteOption>;
  carTypes: Array<ICarType>;
  loading: boolean;
  error?: IError;
  isLoadingOS: boolean;
  isLoadingDS: boolean;
  isLoadingStcc: boolean;
}

export const initialState: State = {
  states: [],
  originStations: [],
  destinationStations: [],
  stcc: [],
  carOwners: [],
  carTypes: [],
  loading: true,
  error: undefined,
  isLoadingOS: false,
  isLoadingDS: false,
  isLoadingStcc: false
};

const rateFormReducer = createReducer(
  initialState,
  on(RateFormActions.loadCarOwnerSuccess, (state, { data }) => ({
    ...state,
    carOwners: data
  })),
  on(RateFormActions.loadCarOwnerFailure, (state, action) => ({
    ...state,
    carOwners: [],
    error: action.error
  })),

  on(RateFormActions.setCarTypesItems, (state, { data }) => ({
    ...state,
    carTypes: data
  })),
  on(RateFormActions.loadCarTypesSuccess, (state, { data }) => ({
    ...state,
    carTypes: data
  })),
  on(RateFormActions.loadCarTypesFailure, (state, action) => ({
    ...state,
    loading: false,
    carTypes: [],
    error: action.error
  })),

  on(RateFormActions.setDestinationStations, (state, { data }) => ({
    ...state,
    destinationStations: data,
    isLoadingDS: false
  })),
  on(RateFormActions.loadDestinationStations, (state, { data }) => ({
    ...state,
    isLoadingDS: true
  })),
  on(RateFormActions.loadDestinationStationsSuccess, (state, { data }) => ({
    ...state,
    destinationStations: data,
    isLoadingDS: false
  })),
  on(RateFormActions.loadDestinationStationsFailure, (state, action) => ({
    ...state,
    isLoadingDS: false,
    destinationStations: [],
    error: action.error
  })),

  on(RateFormActions.setOriginStations, (state, { data }) => ({
    ...state,
    originStations: data,
    isLoadingOS: false
  })),
  on(RateFormActions.loadOriginStations, (state, { data }) => ({
    ...state,
    isLoadingOS: true,
    error: undefined
  })),
  on(RateFormActions.loadOriginStationsSuccess, (state, { data }) => ({
    ...state,
    originStations: data,
    isLoadingOS: false
  })),
  on(RateFormActions.loadOriginStationsFailure, (state, action) => ({
    ...state,
    originStations: [],
    error: action.error,
    isLoadingOS: false
  })),

  on(RateFormActions.setStcc, (state, { data }) => ({
    ...state,
    stcc: data,
    isLoadingStcc: false
  })),
  on(RateFormActions.loadStcc, (state, { data }) => ({
    ...state,
    isLoadingStcc: true
  })),
  on(RateFormActions.loadStccSuccess, (state, { data }) => ({
    ...state,
    stcc: data,
    isLoadingStcc: false
  })),
  on(RateFormActions.loadStccFailure, (state, action) => ({
    ...state,
    isLoadingStcc: false,
    stcc: [],
    error: action.error
  })),

  on(RateFormActions.loadStatesSuccess, (state, { data }) => ({
    ...state,
    states: data,
    loading: false
  })),
  on(RateFormActions.loadStatesFailure, (state, action) => ({
    ...state,
    loading: false,
    states: [],
    error: action.error
  })),
  on(RateFormActions.clearDynamicItems, (state) => ({
    ...state,
    originStations: [],
    destinationStations: [],
    stcc: [],
    carTypes: [],
    isLoadingDS: false,
    isLoadingOS: false,
    isLoadingStcc: false
  }))
);

export const reducer = (state: State | undefined, action: Action) => rateFormReducer(state, action);
